import React, { FC, useCallback, useState } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { RawFile } from "@mapmycustomers/shared/types/File";

import FileUploader from "@app/component/FileUploader";
import { IWizardStep, StandardStep } from "@app/component/wizard";
import { RootState } from "@app/store/rootReducer";

import { areFilesUploading } from "../../store";
import { removeFile, uploadFiles } from "../../store/actions";

import { AddResourcesWizardState } from ".";
import styles from "./AddResourcesWizard.module.scss";

export interface UploadFilesStepProps extends IWizardStep<AddResourcesWizardState> {
  filesUploading: boolean;
  onRemoveFile: typeof removeFile.request;
  onUploadFiles: typeof uploadFiles.request;
}

const UploadFilesStep: FC<UploadFilesStepProps> = ({
  filesUploading,
  onCancel,
  onGoForward,
  onRemoveFile,
  onSetState,
  onUploadFiles,
  ...props
}) => {
  const intl = useIntl();
  const [uploadedFiles, setUploadedFiles] = useState<RawFile[]>([]);
  const handleNext = useCallback(() => {
    onSetState({ files: uploadedFiles });
    onGoForward();
  }, [onGoForward, onSetState, uploadedFiles]);

  const handleChange = useCallback((files: RawFile[]) => {
    setUploadedFiles(files);
  }, []);

  return (
    <StandardStep
      {...props}
      backButtonText={intl.formatMessage({
        id: "resources.add.wizard.resources.upload.cancel",
        defaultMessage: "Cancel",
        description: "Cancel button",
      })}
      nextButtonDisabled={filesUploading || !uploadedFiles.length}
      onCancel={onCancel}
      onGoBack={onCancel}
      onGoForward={handleNext}
      title={intl.formatMessage({
        id: "resources.add.wizard.resources.upload.files.title",
        defaultMessage: "Upload files",
        description: "Upload files modal title",
      })}
    >
      <div className={styles.filesUpload}>
        <FileUploader
          fileUploading={filesUploading}
          onChange={handleChange}
          onFileUpload={onUploadFiles}
          onRemoveFile={onRemoveFile}
        />
      </div>
    </StandardStep>
  );
};

const mapStateToProps = (state: RootState) => ({
  filesUploading: areFilesUploading(state),
});

const mapDispatchToProps = {
  onRemoveFile: removeFile.request,
  onUploadFiles: uploadFiles.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadFilesStep);
